module.exports = __webpack_public_path__ + "img/94.8.TSS.50a0fe97.png";